@let hasAbsenceUpdatePermission =
  can(RoleAction.Update, RolePermissionSubject.Absence);
@let hasAbsenceDeletePermission =
  can(RoleAction.Delete, RolePermissionSubject.Absence);
@let forbiddenMessage = 'general.forbidden_action' | translate;
@let absenceApprovalFlowSettings =
  selectedAbsence | absenceApprovalFlowSettingsPure | async;

@if (
  {
    isAbsenceDrawerVisible: (isAbsenceDrawerVisible$ | async),
  };
  as data
) {
  @if (data.isAbsenceDrawerVisible) {
    <nz-drawer
      [nzVisible]="true"
      [nzMask]="true"
      [nzMaskClosable]="true"
      [nzMaskStyle]="{ backgroundColor: 'transparent' }"
      nzPlacement="right"
      [nzTitle]="drawerHeader"
      [nzFooter]="drawerFooter"
      [nzClosable]="false"
      [nzSize]="'large'"
      (nzOnClose)="closeDrawer()"
    >
      <ng-template #drawerHeader>
        <div class="d-flex justify-content-between align-items-center">
          <span>
            {{ 'page.shift_disposition.gen_template_absence' | translate }}
          </span>
          @if (
            absenceApprovalFlowSettings &&
            absenceApprovalFlowSettings.showApprovalFlow
          ) {
            <div class="d-flex flex-row gap-2">
              <div class="mb-2">
                <wilson-withdraw-absence-button
                  nz-tooltip
                  [nzTooltipTitle]="
                    !hasAbsenceUpdatePermission ? forbiddenMessage : null
                  "
                  [absence]="selectedAbsence"
                  [isSickLeaveOrVacation]="!hasAbsenceUpdatePermission"
                  [showIconOnly]="true"
                  [withdrawRequestInFlight]="withdrawRequestInFlightSignal()"
                  (performWithdrawAbsenceOperation)="withdrawAbsence()"
                  data-test-id="wilson-absence-drawer:withdraw-absence"
                ></wilson-withdraw-absence-button>
              </div>
              <div class="mb-2">
                <wilson-delete-absence-button
                  nz-tooltip
                  [nzTooltipTitle]="
                    !hasAbsenceDeletePermission ? forbiddenMessage : null
                  "
                  [absence]="selectedAbsence"
                  [isDisabled]="!hasAbsenceDeletePermission"
                  [showIconOnly]="true"
                  [deleteRequestInFlight]="deleteRequestInFlightSignal()"
                  (performDeleteAbsenceOperation)="confirmDelete()"
                  data-test-id="wilson-absence-drawer:delete-absence"
                ></wilson-delete-absence-button>
              </div>
            </div>
          }
        </div>
      </ng-template>
      <ng-container *nzDrawerContent>
        @let isAbsenceDrawerLoading = isLoadingSignal();
        @if (isAbsenceDrawerLoading) {
          <nz-skeleton
            [nzActive]="true"
            [nzParagraph]="{ rows: 14 }"
          ></nz-skeleton>
        } @else {
          @if (selectedAbsence) {
            <wilson-absence-status
              [status]="selectedAbsence.status"
            ></wilson-absence-status>
            <wilson-absence-request-approval-section
              [absenceApprovalFlowSettings]="absenceApprovalFlowSettings"
              [absence]="selectedAbsence"
              [acceptRequestInFlight]="acceptRequestInFlightSignal()"
              [declineRequestInFlight]="declineRequestInFlightSignal()"
              [withdrawRequestInFlight]="withdrawRequestInFlightSignal()"
              [deleteRequestInFlight]="deleteRequestInFlightSignal()"
              (acceptAbsence)="acceptAbsence()"
              (declineAbsence)="declineAbsence()"
              (withdrawAbsence)="withdrawAbsence()"
              (deleteAbsence)="confirmDelete()"
              (refreshDataAfterAbsenceDecision)="
                refreshDataAfterAbsenceDecision()
              "
            ></wilson-absence-request-approval-section>
            <nz-divider class="mt-2 mb-0"></nz-divider>
            <wilson-absence-drawer-form
              [form]="form"
              [selectedAbsence]="selectedAbsence"
              (updatedAt)="updatedAt = $event"
              (closeDrawerEvent)="
                absenceDrawerHelperService.toggleAbsenceDrawer(false)
              "
              (updateAbsence)="updateAbsence()"
            ></wilson-absence-drawer-form>
          }
        }
      </ng-container>
      <ng-template #drawerFooter>
        <div class="drawer__footer">
          <wilson-last-update-status
            [updatedAt]="updatedAt"
            [isUpdated]="isSuccessfullySaved()"
          ></wilson-last-update-status>
        </div>
      </ng-template>
    </nz-drawer>
  }
}
